// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "statusMessage-eBXEd";
var _4 = "statusMessage_success-3miPN";
var _5 = "statusMessage_fail-2p6V9";
var _6 = "statusMessage__title-3zrVz";
var _7 = "statusMessage__text-3ClKz";
export { _1 as "__esModule", _2 as "mobile", _3 as "statusMessage", _4 as "statusMessage_success", _5 as "statusMessage_fail", _6 as "statusMessage__title", _7 as "statusMessage__text" }
export default { "__esModule": _1, "mobile": _2, "statusMessage": _3, "statusMessage_success": _4, "statusMessage_fail": _5, "statusMessage__title": _6, "statusMessage__text": _7 }
